import { v4 as uuidv4 } from 'uuid';
import { buildAutoProductContent } from './productWebContent';
import { buildTrendyolProductFirestorePatch } from '../components/trendyol/trendyolProductFormUtils';
import { rejectDeprecatedTestTrendyolBrandId } from './trendyolBrandIds';
import { normalizeAdetIscilikForSave, normalizeIscilikForSave } from './urunPricing';

export const SABIT_KATEGORI = 'Takı Ürün';

export const SUBE_KODLARI = {
  sefakoy_merkez: 'UG001',
  sefakoy_sube: 'UG002',
  kavakli_sube: 'UG003'
};

export const UKBA_GOLD_TRENDYOL_MARKA_ADI = 'UKBA GOLD';

const TRENDYOL_DEFAULT_CARGO_COMPANY_ID = '4';

const EMPTY_IMAGE_URLS = {
  gorselURL1: null,
  gorselURL2: null,
  gorselURL3: null,
  gorselURL4: null,
  gorselURL5: null,
  ty_gorselURL1: null,
  ty_gorselURL2: null,
  ty_gorselURL3: null,
  ty_gorselURL4: null,
  ty_gorselURL5: null
};

export function resolveUkbaTrendyolBrandId(cfg) {
  if (!cfg || typeof cfg !== 'object') return '';
  const bm = cfg.brandMap && typeof cfg.brandMap === 'object' ? cfg.brandMap : {};
  const fromMap = rejectDeprecatedTestTrendyolBrandId(String(bm[UKBA_GOLD_TRENDYOL_MARKA_ADI] ?? '').trim());
  if (fromMap) return fromMap;
  return rejectDeprecatedTestTrendyolBrandId(String(cfg.defaultBrandId ?? '').trim());
}

export function buildUrunEkleTrendyolShipmentBase(cfg) {
  const bid = resolveUkbaTrendyolBrandId(cfg);
  return {
    ty_vatRate: '0',
    ty_dimensionalWeight: '1',
    ty_cargoCompanyId: TRENDYOL_DEFAULT_CARGO_COMPANY_ID,
    ...(bid ? { ty_brandId: bid, ty_brandName: UKBA_GOLD_TRENDYOL_MARKA_ADI } : {})
  };
}

export function generateUrunBarkod(sube) {
  const uuid = uuidv4().slice(0, 8);
  return `${SUBE_KODLARI[sube] || 'UG000'}-${uuid}`;
}

/**
 * urunekle.js handleSubmit ile aynı Firestore payload (timestamp hariç).
 */
export function buildUrunCreatePayload({
  form,
  barkod,
  sube,
  trendyolInfo = {},
  trendyolConfig = {},
  imageUrls = EMPTY_IMAGE_URLS
}) {
  const autoContent = buildAutoProductContent(form);
  const cfg = trendyolConfig && typeof trendyolConfig === 'object' ? trendyolConfig : {};
  const trendyolSource = {
    ...form,
    barkod,
    stokKodu: barkod,
    aciklama: autoContent.description || form.aciklama,
    defaultBrandId: resolveUkbaTrendyolBrandId(cfg),
    defaultVatRate: cfg.defaultVatRate,
    defaultDimensionalWeight: cfg.defaultDimensionalWeight,
    defaultCargoCompanyId: cfg.defaultCargoCompanyId,
    defaultDeliveryDuration: cfg.defaultDeliveryDuration
  };

  const trendyolPatch = buildTrendyolProductFirestorePatch(trendyolInfo, trendyolSource);
  const effectiveTyBrandId =
    rejectDeprecatedTestTrendyolBrandId(String(trendyolInfo.ty_brandId ?? '').trim()) ||
    resolveUkbaTrendyolBrandId(cfg);
  if (effectiveTyBrandId) {
    trendyolPatch.ty_brandId = effectiveTyBrandId;
    trendyolPatch.ty_brandName = UKBA_GOLD_TRENDYOL_MARKA_ADI;
  }

  const urls = { ...EMPTY_IMAGE_URLS, ...imageUrls };

  return {
    barkod,
    isim: form.isim || null,
    kategori: SABIT_KATEGORI,
    urunTipi: form.urunTipi || null,
    aciklama: autoContent.description || form.aciklama || null,
    gram: parseFloat(form.gram) || null,
    uretici: form.uretici || null,
    urunMilyem: form.urunMilyem || null,
    iscilik: normalizeIscilikForSave(form.iscilik),
    adetIscilik: normalizeAdetIscilikForSave(form.adetIscilik),
    stok: parseInt(form.stok, 10) || null,
    siteLinki: form.siteLinki || null,
    pazaryeriLinki: form.pazaryeriLinki || null,
    ikasCategoryIds: Array.isArray(form.ikasCategoryIds) ? form.ikasCategoryIds : [],
    ikasCategoryNamesSnapshot: Array.isArray(form.ikasCategoryNamesSnapshot) ? form.ikasCategoryNamesSnapshot : [],
    ikasCategoryId:
      (Array.isArray(form.ikasCategoryIds) ? form.ikasCategoryIds[0] : '') || form.ikasCategoryId || null,
    urunKategorisi:
      (Array.isArray(form.ikasCategoryNamesSnapshot) ? form.ikasCategoryNamesSnapshot[0] : '') ||
      form.urunKategorisi ||
      null,
    urunCapi: form.urunCapi || null,
    tasOzelligi: form.tasOzelligi || null,
    zincirUzunlugu: form.zincirUzunlugu || null,
    urunRengi: form.urunRengi || null,
    ws_slug: autoContent.slug || null,
    ws_seoBaslik: autoContent.seoTitle || null,
    ws_seoAciklama: autoContent.seoDescription || null,
    ws_seoAnahtarKelimeler: autoContent.seoKeywords || null,
    ws_canonicalUrl: autoContent.canonical || null,
    ty_slug: autoContent.slug || null,
    ty_seoBaslik: autoContent.seoTitle || null,
    ty_seoAciklama: autoContent.seoDescription || null,
    ty_seoAnahtarKelimeler: autoContent.seoKeywords || null,
    ...trendyolPatch,
    ...urls,
    subeId: sube
  };
}
